/**
 * Add your config changes here.
 * @module config
 */
import bookSVG from '@plone/volto/icons/book.svg';
import RubricaView from '@package/components/Blocks/Rubrica/View.jsx';
import RubricaEdit from '@package/components/Blocks/Rubrica/Edit.jsx';
import FarmaciaView from '@package/components/View/FarmaciaView/FarmaciaView.jsx';
import farmacieSVG from '@plone/volto/icons/first-aids.svg';
import psSVG from '@plone/volto/icons/first-aids.svg';
import ambulatorioSVG from '@plone/volto/icons/home.svg';
import SearchFarmaciaView from '@package/components/Blocks/SearchFarmacia/View.jsx';
import SearchFarmaciaEdit from '@package/components/Blocks/SearchFarmacia/Edit.jsx';
import SearchAmbulatorioView from '@package/components/Blocks/SearchAmbulatorio/View.jsx';
import SearchAmbulatorioEdit from '@package/components/Blocks/SearchAmbulatorio/Edit.jsx';
import PSTimesEdit from '@package/components/Blocks/PSTimes/Edit.jsx';
import PSTimesView from '@package/components/Blocks/PSTimes/View.jsx';
import BandiSearchVariationTable from '@package/components/Blocks/BandiSearch/Variations/BandiSearchVariationTable';
import applyItaliaConfig from '@italia/config/italiaConfig';
import '@plone/volto/config';
import BlocksWidget from '@package/components/Widgets/BlocksWidget';
import PersonaAmbulatori from '@package/components/View/PersonaView/PersonaAmbulatori';
import SiteTitle from '@package/components/layout/SiteTitle/SiteTitle';
import { SelectionSchemaExtender } from '@package/components/Blocks/FormBlock/SelectionSchemaExtender';
import DateViewWidget from '@package/components/Widgets/DateViewWidget';
import AccessiWay from '@package/components/AccessiWay/AccessiWay';

// TODO: temporanea fiino al merge e all'upgrade della funzionalità dei filtri in volto-form-block
import FormBlockEdit from '@package/components/Blocks/FormBlock/Edit';
import QuerystringHiddenWidget from '@package/components/Blocks/FormBlock/QuerystringHiddenWidget';
import { QuerystringHiddenSchemaExtender } from '@package/components/Blocks/FormBlock/QuerystringHiddenSchemaExtender';

// import { defineMessages } from 'react-intl';
// import SearchBlockView from '@plone/volto/components/manage/Blocks/Search/SearchBlockView';
// import SearchBlockEdit from '@plone/volto/components/manage/Blocks/Search/SearchBlockEdit';
// import SearchBlockSchema from '@plone/volto/components/manage/Blocks/Search/schema';
// import searchSVG from '@plone/volto/icons/zoom.svg';
// import RightColumnFacets from '@plone/volto/components/manage/Blocks/Search/layout/RightColumnFacets';
// import LeftColumnFacets from '@plone/volto/components/manage/Blocks/Search/layout/LeftColumnFacets';
// import TopSideFacets from '@plone/volto/components/manage/Blocks/Search/layout/TopSideFacets';
// import {
//   SelectFacet,
//   CheckboxFacet,
//   DateRangeFacet,
//   ToggleFacet,
//   ToggleFacetFilterListEntry,
//   SelectFacetFilterListEntry,
//   DateRangeFacetFilterListEntry,
// } from '@plone/volto/components/manage/Blocks/Search/components';

import {
  ContentImage,
  VenueDescription,
  VenueServices,
  VenueAccessMode,
  VenueWhere,
  VenuePublicTimetable,
  VenueContacts,
  VenueMoreInfos,
  UOWhatDoesItDo,
  UOContacts,
  UOPeople,
  UOStructure,
  UOServices,
  UODocuments,
  UOMoreInfos,
  BandoText,
  BandoUfficioResponsabile,
  BandoAreaResponsabile,
  BandoServizi,
  BandoDate,
  BandoApprofondimenti,
  BandoUlterioriInformazioni,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

import BandoSchemaOrg from '@package/components/View/BandoView/BandoSchemaOrg';

// defineMessages({
//     // Search block variations
//     facetsRightSide: {
//       id: 'Facets on right side',
//       defaultMessage: 'Facets on right side',
//     },
//     facetsLeftSide: {
//       id: 'Facets on left side',
//       defaultMessage: 'Facets on left side',
//     },
//     facetsTopSide: {
//       id: 'Facets on top',
//       defaultMessage: 'Facets on top',
//     },
//     selectFacet: {
//       id: 'selectFacet',
//       defaultMessage: 'Select',
//     },
//     checkboxFacet: {
//       id: 'checkboxFacet',
//       defaultMessage: 'Checkbox',
//     },
//     daterangeFacet: {
//       id: 'daterangeFacet',
//       defaultMessage: 'Date Range',
//     },
//     toggleFacet: {
//       id: 'toggleFacet',
//       defaultMessage: 'Toggle',
//     },
// });

export default function applyConfig(voltoConfig) {
  const config = applyItaliaConfig(voltoConfig);

  config.blocks.blocksConfig.form = {
    ...config.blocks.blocksConfig.form,
    enableDatatableView: true,
    edit: FormBlockEdit,
    fieldTypeSchemaExtenders: {
      ...config.blocks.blocksConfig.form.fieldTypeSchemaExtenders,
      select: SelectionSchemaExtender,
      single_choice: SelectionSchemaExtender,
      multiple_choice: SelectionSchemaExtender,
      querystring_hidden: QuerystringHiddenSchemaExtender,
    },
    additionalFields: [
      ...(config.blocks.blocksConfig.form.additionalFields ?? []),
      {
        id: 'querystring_hidden',
        label: "Parametro dall'URL (nascosto)",
        component: QuerystringHiddenWidget,
      },
    ],
  };

  config.settings = {
    ...config.settings,
    externalRoutes: [
      ...config.settings.externalRoutes,
      {
        match: {
          path: '/Shibboleth.sso/Logout',
          exact: true,
          strict: false,
        },
      },
      {
        match: {
          path: '/secure',
          strict: false,
        },
      },
      // {
      //   url(payload) {
      //     return payload.location.pathname;
      //   },
      // },
    ],

    //  defaults
    matomoUrlBase: 'https://piwik.auslromagna.it/matomo/',
    matomoSiteId: '3',
    // matomoSecondUrlBase
    // matomoSecondSiteId
    // TODO: riverificare queste impostazioni
    matomo: {
      ...(config.settings.matomo || {}),
      configurations: {
        ...(config.settings.matomo?.configurations || {}),
        setCookieDomain: '.auslromagna.it',
        setDomains: [
          '*.auslromagna.it',
          '*.amministrazionetrasparente.auslromagna.it',
          '*.www.auslromagna.it',
          '*.amministrazionetrasparente.auslromagna.it',
          '*.bancadellacute.auslromagna.it',
          '*.bollettino.auslromagna.it',
          '*.forms.auslromagna.it',
          '*.sondaggi.auslromagna.it',
        ],
        enableCrossDomainLinking: true,
        setDoNotTrack: true,
        disableCookies: true,
        enableLinkTracking: true,
      },
    },
    italiaThemeViewsConfig: {
      ...config.settings.italiaThemeViewsConfig,
      //imagePosition: 'afterHeader', // possible values: afterHeader, documentBody

      Venue: {
        ...(config.settings.italiaThemeViewsConfig['Venue'] ?? {}),
        sections: [
          {
            /* HEADER IMAGE */
            component: ContentImage,
            props: { position: 'documentBody' },
          },
          { /* DESCRIZIONE */ component: VenueDescription },
          { /* MAPPA */ component: VenueWhere },
          { /* CONTATTI */ component: VenueContacts },
          { /* ORARIO AL PUBBLICO */ component: VenuePublicTimetable },
          { /* MODALITA DI ACCESSO */ component: VenueAccessMode },
          { /* SERVIZI CORRELATI */ component: VenueServices },
          { /* ULTERIORI INFORMAZIONI */ component: VenueMoreInfos },
        ],
      },
      Persona: {
        ...config.settings.italiaThemeViewsConfig.Persona,
        // persona è sovrascritto anche da alp (libera professione),
        // qui si inserisce la sezione "AMBULATORI", prima dell'ultima sezione
        // (che è / dovrebbe essere "ULTERIORI INFORMAZIONI")
        sections: config.settings.italiaThemeViewsConfig.Persona.sections
          .slice(
            0,
            config.settings.italiaThemeViewsConfig.Persona.sections.length - 1,
          )
          .concat([{ /* AMBULATORI */ component: PersonaAmbulatori }])
          .concat(
            config.settings.italiaThemeViewsConfig.Persona.sections.slice(
              config.settings.italiaThemeViewsConfig.Persona.sections.length -
                1,
            ),
          ),

        // { /* RUOLO */ component: PersonaRuolo },
        // { /* CONTATTI */ component: PersonaContatti },
        // { /* LIBERA PROFESSIONE */ component: PersonaLiberaProfessione }, <-- aggiunto da auslfe-alp
        // { /* DOCUMENTI */ component: PersonaDocumenti },
        // { /* ULTERIORI INFORMAZIONI */ component: PersonaUlterioriInformazioni },
      },
      UnitaOrganizzativa: {
        ...(config.settings.italiaThemeViewsConfig['Venue'] ?? {}),
        sections: [
          {
            /* HEADER IMAGE */
            component: ContentImage,
            props: { position: 'documentBody' },
          },
          { /*** COSA FA ***/ component: UOWhatDoesItDo },
          { /*** CONTATTI ***/ component: UOContacts },
          { /*** STAFF ***/ component: UOPeople },
          { /*** STRUTTURA ***/ component: UOStructure },
          { /*** SERVIZI ***/ component: UOServices },
          { /* DOCUMENTI */ component: UODocuments },
          { /* ULTERIORI INFORMAZIONI */ component: UOMoreInfos },
        ],
      },
      Bando: {
        ...(config.settings.italiaThemeViewsConfig.Bando ?? {}),
        sections: [
          { /* Schema Org */ component: BandoSchemaOrg },
          { /* Testo */ component: BandoText },
          /* Responsabili */
          { /* UFFICIO */ component: BandoUfficioResponsabile },
          { /* AREA */ component: BandoAreaResponsabile },
          { /* SERVIZI */ component: BandoServizi },
          { /* DATE IMPORTANTI  */ component: BandoDate },
          {
            /* ALLEGATI (CARTELLE APPROFONDIMENTI)  */ component:
              BandoApprofondimenti,
          },
          {
            /* ULTERIORI INFORMAZIONI  */ component: BandoUlterioriInformazioni,
          },
        ],
      },
    },

    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Servizio Sanitario Regionale Emilia-Romagna',
      siteSubtitle: 'Azienda Unità Sanitaria Locale della Romagna',
      parentSiteTitle: 'Portale Salute Regione Emilia-Romagna',
      parentSiteURL: 'https://salute.regione.emilia-romagna.it/',
      subsiteParentSiteTitle: 'AUSL della Romagna',
      arLoginUrl: '/area-dipendenti',
      // arLogoutUrl: '/logout',
      markSpecialLinks: false,
      // smallFooterLinks: {
      //   default: [{ title: 'Mappa del sito', url: '/sitemap' }],
      //   it: [{ title: 'Mappa del sito', url: '/it/sitemap' }],
      //   en: [{ title: 'Sitemap', url: '/en/sitemap' }],
      // },
    },
    isMultilingual: false,
    supportedLanguages: ['it', 'en'],
    defaultLanguage: 'it',
  };

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Farmacia: FarmaciaView,
  };

  config.widgets.widget = {
    ...config.widgets.widget,
    blocks: BlocksWidget,
  };
  config.widgets.id.data_archiviazione = DateViewWidget;

  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    variations: [
      ...config.blocks.blocksConfig.listing.variations,
      // {
      //   id: 'cardWithSideImageTemplate',
      //   isDefault: false,
      //   title: 'Card con immagine affiancata',
      //   template: CardWithSideImageTemplate,
      //   skeleton: CardWithSideImageTemplateSkeleton,
      //   schemaEnhancer: ({ schema, formData, intl }) => {
      //     let pos = addDefaultOptions(schema, formData, intl);
      //     addCardWithSideImageTemplateOptions(schema, formData, intl, pos);
      //     return schema;
      //   },
      // },
    ],
    listing_bg_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
    listing_items_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
  };

  config.blocks.blocksConfig.rubrica = {
    id: 'rubrica',
    title: 'Rubrica',
    icon: bookSVG,
    group: 'search',
    view: RubricaView,
    edit: RubricaEdit,
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 0,
  };

  config.blocks.blocksConfig.searchFarmacia = {
    id: 'searchFarmacia',
    title: 'Ricerca farmacie', // ricerca turni o ferie farmacie
    icon: farmacieSVG,
    group: 'search',
    view: SearchFarmaciaView,
    edit: SearchFarmaciaEdit,
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.searchAmbulatori = {
    id: 'searchAmbulatori',
    title: 'Ricerca ambulatori', // ricerca turni o ferie farmacie
    icon: ambulatorioSVG,
    group: 'search',
    view: SearchAmbulatorioView,
    edit: SearchAmbulatorioEdit,
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.psTimes = {
    id: 'psTimes',
    title: 'Tempi PS', // tempi del Pronto Soccorso
    icon: psSVG,
    group: 'common',
    view: PSTimesView,
    edit: PSTimesEdit,
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.searchBandi = {
    ...config.blocks.blocksConfig.searchBandi,
    results_variations: [
      { id: 'table', name: 'Tabella', component: BandiSearchVariationTable },
    ],
  };
  // XXX: io-Comune v3 disabilita il blocco search, lo riabilitiamo
  //      verifichiamo gli stili, eliminado eventualmente delle variation
  //      e aggiungendo quelle che servono (es. ricerca ambulatori)
  // config.blocks.blocksConfig.search = {
  //   id: 'search',
  //   title: 'Search',
  //   icon: searchSVG,
  //   group: 'common',
  //   view: SearchBlockView,
  //   edit: SearchBlockEdit,
  //   blockSchema: SearchBlockSchema,
  //   restricted: false,
  //   mostUsed: false,
  //   sidebarTab: 1,
  //   variations: [
  //     // {
  //     //   id: 'facetsRightSide',
  //     //   title: 'Facets on right side',
  //     //   view: RightColumnFacets,
  //     //   isDefault: false,
  //     // },
  //     // {
  //     //   id: 'facetsLeftSide',
  //     //   title: 'Facets on left side',
  //     //   view: LeftColumnFacets,
  //     //   isDefault: false,
  //     // },
  //     {
  //       id: 'facetsTopSide',
  //       title: 'Facets on top',
  //       view: TopSideFacets,
  //       isDefault: true,
  //     },
  //   ],
  //   extensions: {
  //     facetWidgets: {
  //       rewriteOptions: (name, choices) => {
  //         return name === 'review_state'
  //           ? choices.map((opt) => ({
  //               ...opt,
  //               label: opt.label.replace(/\[.+\]/, '').trim(),
  //             }))
  //           : choices;
  //       },
  //       types: [
  //         {
  //           id: 'selectFacet',
  //           title: 'Select',
  //           view: SelectFacet,
  //           isDefault: true,
  //           schemaEnhancer: SelectFacet.schemaEnhancer,
  //           stateToValue: SelectFacet.stateToValue,
  //           valueToQuery: SelectFacet.valueToQuery,
  //           filterListComponent: SelectFacetFilterListEntry,
  //         },
  //         {
  //           id: 'checkboxFacet',
  //           title: 'Checkbox',
  //           view: CheckboxFacet,
  //           isDefault: false,
  //           schemaEnhancer: CheckboxFacet.schemaEnhancer,
  //           stateToValue: CheckboxFacet.stateToValue,
  //           valueToQuery: CheckboxFacet.valueToQuery,
  //           filterListComponent: SelectFacetFilterListEntry,
  //         },
  //         {
  //           id: 'daterangeFacet',
  //           title: 'Date range',
  //           view: DateRangeFacet,
  //           isDefault: false,
  //           stateToValue: DateRangeFacet.stateToValue,
  //           valueToQuery: DateRangeFacet.valueToQuery,
  //           filterListComponent: DateRangeFacetFilterListEntry,
  //         },
  //         {
  //           id: 'toggleFacet',
  //           title: 'Toggle',
  //           view: ToggleFacet,
  //           isDefault: false,
  //           stateToValue: ToggleFacet.stateToValue,
  //           valueToQuery: ToggleFacet.valueToQuery,
  //           filterListComponent: ToggleFacetFilterListEntry,
  //         },
  //       ],
  //     },
  //   },
  // };

  config.settings['volto-blocks-widget'].allowedBlocks = [
    ...config.settings['volto-blocks-widget'].allowedBlocks,
    'repeatableContentBlock',
  ];

  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: {
      ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
      last_updated: '2024-05-06T14:00:00+00:00',
      technical: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
        choices: [
          {
            config_key: 'MATOMO',
            text: {
              it: {
                title: 'Matomo',
                description:
                  "I cookie di Matomo sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
              },
              en: {
                title: 'Matomo',
                description:
                  'Matomo cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
              },
            },
          },
          // ...config.settings[
          //   'volto-gdpr-privacy'
          // ].defaultPanelConfig.technical.choices.filter(
          //   (f) => f.config_key !== 'GANALYTICS',
          // ),
        ],
      },
    },
  };
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: SiteTitle,
    },
    {
      match: '',
      component: AccessiWay,
    },
  ];

  return config;
}
